import React from 'react';
import {Card, Col, Container,} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../Store/Reducers";
import LoadingComponent from "../../Shared/LoadingComponent";
import ShipmentCardComponent from "./ShipmentCardComponent";
import {LoadingContainer} from "../../Shared/Helpers";
import Pickup from "../../../Models/Pickup";
import {ModalActions} from "../../../Store/Modal/Slice";
import {SHIPPING_DETAIL_MODAL} from "../../../Store/Modal/Types";
import {getColumnStyle} from "../../../Utils/Utils";
import PickupCardComponent from "./PickupCardComponent";
import Shipment from "../../../Models/Shipment";

const ShipmentBoardComponent = () => {

  const dispatch = useDispatch();

  const {PickupReducer : {pickups, shipments}, LoadingReducer : {loadingPickups}} = useSelector((state: RootState) => state);

  const openShippingDetail = (data: Pickup | Shipment, isShipment?: boolean) => {
    dispatch(ModalActions.openModal({modal: SHIPPING_DETAIL_MODAL, data: {shippingInfo: data, isShipment: isShipment}}));
  };

  return (
    <Container fluid>
      <Card className="dashboard-main-card">
        <div className="p-2">
          {
            loadingPickups.status.isLoading() &&
            <LoadingContainer>
              <LoadingComponent loading={loadingPickups.status}/>
            </LoadingContainer>
          }

          <div className="d-flex flex-wrap">
            {
              pickups?.map((pickup, index) => {
                return (
                  <Col key={index+'_dashboard_card'} sm={6} lg={4} xl={3} >
                    <PickupCardComponent pickup={pickup} columnStyle={getColumnStyle(pickup?.status)}
                                           handleClick={openShippingDetail}/>
                  </Col>
                );
              })
            }

            {
              shipments?.map((shipment, index) => {
                return (
                  <Col key={index+'_dashboard_card'} sm={6} lg={4} xl={3} >
                    <ShipmentCardComponent shipment={shipment} columnStyle={getColumnStyle(shipment?.status)}
                                           handleClick={(shipment) => openShippingDetail(shipment, true)}/>
                  </Col>
                );
              })
            }

            {
              !Boolean(pickups?.length) && !Boolean(shipments?.length) && !loadingPickups.status.isLoading() &&
                <span className="p-3">
                  No hay envios registrados.
                </span>
            }
          </div>

        </div>
      </Card>
    </Container>
  );
};

export default ShipmentBoardComponent;
